import * as actionTypes from "./actionTypes";

export const getAllWallOfFame = (allWallOfFame, totalWallOfFame) => {
  return {
    type: actionTypes.GET_ALL_WALL_OF_FAME,
    wallOfFame: allWallOfFame,
    total: totalWallOfFame,
  };
};

export const updateWallOfFame = (singlePost) => {
  return {
    type: actionTypes.UPDATE_WALL_OF_FAME,
    post: singlePost,
  };
};

export const createWallOfFame = (singlePost) => {
  return {
    type: actionTypes.CREATE_WALL_OF_FAME,
    post: singlePost,
  };
};

export const deleteWallOfFame = (singlePost) => {
  return {
    type: actionTypes.DELETE_WALL_OF_FAME,
    post: singlePost,
  };
};

export const setWallOfFameLoader = (loaderValue) => {
  return {
    type: actionTypes.SET_WALL_OF_FAME_LOADER,
    loaderValue: loaderValue,
  };
};

export const pageWallOfFameIncreament = () => {
  return {
    type: actionTypes.PAGE_INCREAMENT_WALL_OF_FAME,
  };
};

export const clearWallOfFameAll = () => {
  return {
    type: actionTypes.CLEAR_ALL_WALL_OF_FAME,
  };
};

// export const getSinglePost = (myPost) => {
//   return {
//     type: actionTypes.GET_SINGLE_POST,
//     post: myPost,
//   };
// };

// export const clearSinglePost = () => {
//   return {
//     type: actionTypes.CLEAR_SINGLE_POST,
//   };
// };
